import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import { TriangleAlert } from 'lucide-react'
import { GetReturnLossResponseData } from '@/modules/promotion/type'
import ReturnLossTable from '../ReturnLossTable'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'

interface ReturnLossListingProps {
	data: GetReturnLossResponseData[]
	total: number
	isLoading?: boolean
}

export default function ReturnLossListing({
	data,
	total,
	isLoading,
}: ReturnLossListingProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_RETURN_LOSS,
	)

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`รายการคืนยอดเสีย`}
					description="การคืนเครดิตยอดเสียจะคิดเมื่อลูกค้าเล่นแบบไม่ฝากโปร"
				/>
				{hasWritePermission && (
					<Button asChild variant="default">
						<Link to="/operator/return-loss/create-return-loss">
							เพิ่มคืนยอดเสีย
						</Link>
					</Button>
				)}
			</div>
			<Separator />
			<div className="flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm dark:border-amber-800 dark:bg-amber-950/30">
				<TriangleAlert className="mt-0.5 h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400" />
				<div className="text-amber-800 dark:text-amber-200">
					<p className="font-medium">การตั้งค่าคืนยอดเสียเชื่อมโยงกับแรงค์</p>
					<p className="mt-0.5">
						รายการคืนยอดเสียจะมีผลต่อผู้เล่นเมื่อถูกเชื่อมกับแรงค์ที่ต้องการแล้วเท่านั้น{' '}
						<Link
							to="/operator/rank"
							className="font-medium underline underline-offset-2 hover:text-amber-900 dark:hover:text-amber-100"
						>
							ไปที่จัดการแรงค์ →
						</Link>
					</p>
				</div>
			</div>
			<ReturnLossTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
